import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../services/authApi';
import './Pages.css';

export const VerifyEmail: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('O link de confirmação está incompleto. Abra o link recebido por e-mail.');
      setLoading(false);
      return;
    }
    verifyEmail(token)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch((reason) => setError(reason instanceof Error ? reason.message : 'Não foi possível confirmar o e-mail.'))
      .finally(() => setLoading(false));
  }, [navigate, params]);

  return (
    <div className="ns-login">
      <div className="ns-login-panel">
        <div className="ns-login-header"><div className="ns-login-logo"><span className="mark">NS</span><span className="text">NutriSync</span></div></div>
        <p>{loading ? 'Confirmando seu e-mail…' : error || 'E-mail confirmado.'}</p>
        {!loading && error && <p className="ns-login-footer"><Link to="/login">Voltar ao login</Link></p>}
      </div>
    </div>
  );
};
